import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'clp-loading-overlay',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './loading-overlay.component.html',
  styleUrl: './loading-overlay.component.scss'
})
export class LoadingOverlayComponent {
  private readonly loadingService = inject(LoadingService);

  readonly isLoading$ = this.loadingService.isLoading$;
}
